export const isLocalDevelopment = (): boolean => {
  if (typeof window !== 'undefined') {
    const { hostname } = window.location;

    if (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === '0.0.0.0'
    ) {
      return true;
    }
  }

  return process.env.NODE_ENV === 'development';
};
